/* eslint-disable react/require-default-props */
import cn from 'libs/bem'
import React, { ElementType } from 'react'
import './typography.scss'

export type Props = {
  children?: React.ReactNode
  color?: string
  type?:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'h7'
    | 'h8'
    | 'body1'
    | 'body2'
    | 'body3'
    | 'body4'
    | 'body5'
    | 'body6'
  componentAs?: ElementType
  className?: string
  nowrap?: boolean
  handleClick?: () => void
  style?: object
}
const Typography: React.FC<Props> = (props: Props) => {
  const {
    type = 'body1',
    children,
    color = '#2f3b55',
    componentAs: TypographyComponent = 'div',
    className,
    nowrap = false,
    handleClick = () => {},
    style = {},
  } = props
  const classes = cn('typography')
  const classNames = [classes({ type, nowrap })]
  if (className) classNames.push(className)
  return (
    <TypographyComponent
      className={classNames.join(' ')}
      style={{ color, ...style }}
      data-testid="typography"
      onClick={handleClick}
    >
      {children}
    </TypographyComponent>
  )
}

export default Typography
